/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookies_Necessary_TitleInputs */

const en_cookies_necessary_title = /** @type {(inputs: Cookies_Necessary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strictly necessary`)
};

const pl_cookies_necessary_title = /** @type {(inputs: Cookies_Necessary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezwzględnie niezbędne`)
};

/**
* | output |
* | --- |
* | "Strictly necessary" |
*
* @param {Cookies_Necessary_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const cookies_necessary_title = /** @type {((inputs?: Cookies_Necessary_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookies_Necessary_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_cookies_necessary_title(inputs)
	return en_cookies_necessary_title(inputs)
});